import { createClient } from "@supabase/supabase-js";

// CRA 는 REACT_APP_ 접두어가 붙은 것만 번들에 넣는다.
// anon 키는 브라우저에 노출되는 게 정상이다 (RLS가 실제 방어선).
// service_role 키는 절대 여기 넣지 말 것.
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY 가 설정되지 않았습니다. .env.local 을 확인하세요."
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
